export default "__VITE_ASSET__BNDq_mwM__"